module.exports = __webpack_public_path__ + "img/bg43.1e4c749f.png";